import React, { Component } from 'react';
//import axios from 'axios';
import api from "./../../../services/api";
import './style.css';
import { NavLink } from 'react-router-dom';
import { user_token } from "../../../services/Auth";
import { Bounce } from 'react-activity';
import 'react-activity/dist/react-activity.css'

var token = localStorage.getItem(user_token);
var _id = localStorage.getItem("id_agent");

/*
  const request = await api.get(`http://api-convida.herokuapp.com/user/institucion/${_id}`, { headers: { 'x-access-token': token } });
    console.log(request);
    console.log(request.data);
    this.setState({ usuarios: request.data });
*/

//Classe para API
export default class PacientList extends Component{
  state = {
    usuarios: [],
    loading: false,
  }

  componentDidMount(){
    this.loadDataUser();
  }

  loadDataUser = async () => {
    this.setState({loading: true})
    const request = await api.get(`/user/agent/${_id}`, { headers: { 'x-access-token': token } });
    console.log(request);
    console.log(request.data);
    this.setState({ usuarios: request.data });
    this.setState({loading: false})
  };

  //loadDataUser = async () => {
    
    
  //};
  
  render(){   
    return(
      <>
        <div id="lista-style">
           
          { this.state.usuarios.map(users => (
          <>
            <NavLink to={{pathname:"/RI_PacientesDetalhes/"+ users._id}}><button id="RI-ListaPacientes" key={users._id}>{users.name}</button></NavLink>
          </>
          ))}
          {this.state.loading === true ? <Bounce 
            size={30}
            color="rgb(200,70,90)"
            speed={1}
          /> : null }          
        </div>
      </>

    );
  }

}